import script from "./historyModel.vue?vue&type=script&setup=true&lang=js"
export * from "./historyModel.vue?vue&type=script&setup=true&lang=js"

import "./historyModel.vue?vue&type=style&index=0&id=9f0577ca&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f0577ca"]])

export default __exports__